import { Toast, Indicator } from "mint-ui";

// 控制路由，保证路由为单次跳转
var shouldBackState = true;
const mixins = {
  data() {
    return {
      address: {
        poiName: "三坊七巷",
        city: "福州市",
        district: "鼓楼区",
        street: "保福路",
        streetNum: "79号",
        cityCode: "0591",
        location: "119.296405,26.082247"
      },
    };
  },
  methods: {

    getNowFormatDate() {
      //获取当前时间
      // var date = new Date();

      var date =  Date.parse(new Date())/1000;

      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var currentdate =
        date.getFullYear() +
        month +
        strDate +
        date.getHours() +
        date.getMinutes() +
        date.getSeconds();
      return currentdate;
    },

     randomNumber() 
    {
        const now = new Date()
        let month = now.getMonth() + 1
        let day = now.getDate()
        let hour = now.getHours()
        let minutes = now.getMinutes()
        let seconds = now.getSeconds()
        month = month < 10 ? "0" + month : month;
        day = day < 10 ? "0" + day : day;
        hour = hour < 10 ? "0" + hour : hour;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        let orderCode = now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds ;
        return orderCode;
    },

    /**
     * 获取定位,返回城市名称，如:福州市
    * */
    getPos() {
      let _this = this;
      return new Promise((resolve, reject) => {
        try {
          plus.geolocation.getCurrentPosition(
            function (position) {
              console.log('getPos success', position)
              if (position) {
                if (position.address.poiName) {
                  _this.address.poiName = position.address.poiName;
                } else {
                  _this.address.poiName = position.addresses;
                }
                _this.address.city = position.address.city;
                _this.address.cityCode = position.address.cityCode;
                _this.address.street = position.address.street;
                _this.address.streetNum = position.address.streetNum;
                _this.address.district = position.address.district;
                // if (_this.isIOS()) {
                //   // console.log('进入ios定位')
                //   // console.log('转化前position定位')
                //   // console.log(position)

                //   // //IOS系统需要将获取的坐标进行转码
                //   // var newlocation = coordtransform.wgs84togcj02(
                //   //   position.coords.longitude,
                //   //   position.coords.latitude
                //   // );
                //   // _this.address.location = `${newlocation[0]},${
                //   //   newlocation[1]
                //   // }`;
                //   // console.log('转化后address')
                //   // console.log(_this.address)
                //   _this.address.location = `${position.coords.longitude},${
                //     position.coords.latitude
                //   }`;  

                //   console.log("IOS转码坐标:" + _this.address.location);
                // } else {
                //   _this.address.location = `${position.coords.longitude},${
                //     position.coords.latitude
                //   }`;
                //   // console.log("非IOS坐标:" + _this.address.location);
                // }
                _this.address.location = `${position.coords.longitude},${
                  position.coords.latitude
                  }`;
                console.log('s地址打印1',  _this.address)
                resolve(position.address.city);
              }
            },
            function (e) {
              console.log('s地址打印2')
              // Toast("获取定位位置信息失败");
              _this.address.poiName = "福州市";
              _this.address.city = "福州市";
              _this.address.cityCode = "0591";
              _this.address.street = "";
              _this.address.streetNum = "";
              _this.address.district = "";
              _this.address.location = "119.296784,26.082408";
              resolve("福州市");
            },
            {
              geocode: true
            }
          );
        } catch (e) {
          console.log('s地址打印3')
          _this.address.poiName = "福州市";
          _this.address.city = "福州市";
          _this.address.cityCode = "0591";
          _this.address.street = "";
          _this.address.streetNum = "";
          _this.address.district = "";
          _this.address.location = "119.296784,26.082408";
          resolve("福州市");
        }
      }).catch(err => {
        console.log('s地址打印3 错误')
      });
    },
    /**
     * 跳转地址,push,不传参
    * */
    getmodel(routerName) {
      this.$router.pushPage(routerName);
    },
    /**
     * 公用若提示(msg, time)
    * */
    tips(str, times = 1500) {
      Toast({
        message: "" + str,
        position: "center",
        duration: times
      });
    },
    /**
     * 获取指定缓存并返回，否则返回null (sessionStorageName)
    * */
    getSessionItem(sessionName) {
      return sessionStorage.getItem(sessionName) ? sessionStorage.getItem(sessionName) : null;
    },
    parseJstatus(jstatus){
      if(jstatus==1){
        return  '正常';
      }  else if(jstatus==2){
         return  '红冲';
      }else {

        return  '作废';
      }
    },
    parsefplx(fplx){

       if(fplx=='026'){
          return  '增值税普票';
       }else if(fplx=='007'){
        return  '增值税纸票';
       }else if(fplx=='82'){
        return  '数电普票';
       }else if(fplx=='81'){
        return  '数电专票';
       }else{
         return  '专票';
       }

    },
    /**
     * 清除临时指定缓存Array[sessionStorageName]
    * */
    clearTempSession(sessionArry) {
      sessionArry.forEach(item => {
        if (sessionStorage.getItem(item)) { sessionStorage.removeItem(item) }
      })
    },
    //判断历史记录
    jugeHistory() {
      let that = this;
      if (typeof plus == "undefined") {
        window.addEventListener(
          "popstate",
          function () {
            /**
             * 判断作用：如果是自定义路由就不要再次调用方法
             * */
            if (shouldBackState) {
              // console.log("调用历史记录返回")
              that.dealHistory();
            } else {
              // console.log('进来,此时历史记录没有')
              shouldBackState = true;
            }
          },
          false
        );
      }
      mui.init({
        keyEventBind: {
          backbutton: true //关闭back按键监听
        }
      });
      // //首页返回键处理
      // //处理逻辑：1秒内，连续两次按返回键，则退出应用；
      var first = null;
      mui.plusReady(function () {
        mui.back = function () {
          console.log('点击返回键')
          if (sessionStorage.getItem("router_name") === "home") {
            //跟路由返回键处理
            //处理逻辑：1秒内，连续两次按返回键，则退出应用；
            console.log('处于首页')
            if (!first) {
              console.log('点击退出第一次')
              first = new Date().getTime();
              mui.toast("再按一次退出应用");
              setTimeout(function () {
                first = null;
                console.log('退出第一次失效')
              }, 1000);
            } else {
              console.log('退出第二次失效')
              if (new Date().getTime() - first < 1000) {
                console.log('退出第二次成功，执行退出')
                plus.runtime.quit();
              }
            }
          } else {
            try {
              //关闭上传照片窗口
              Indicator.close();
            } catch (error) { }
            that.back();
          }
        };
      });
    },
    // 此处处理路由跳转
   
    // 不启用返回时候(此方法有些问题，返回时候如果只返回一层可以使用)
    jugeBackGoto(num) {
      shouldBackState = false;
      this.$router.back(num);
    },
    // 返回
    back() {
      let that = this;
      //that.dealHistory(() => {
        that.jugeBackGoto(-1);
      //});
    },
    // 带参数跳转（push）
    getmodelParam(routerName, params) {
      this.$router.pushPage(routerName, params);
    },
    // replace替换路由
    replaceModel(routerName) {
      this.$router.replacePage(routerName);
    },
    // replace替换路由并传参
    replaceModelParam(routerName, params) {
      this.$router.replacePage(routerName, params);
    },
    //数组对象去重
    ///objArray数组
    ///propertyName对象判重属性
    ArrayUniq(objArray, propertyName) {
      var hash = {};
      //reduce方法有两个参数，第一个参数是一个callback，用于针对数组项的操作；第二个参数则是传入的初始值，这个初始值用于单个数组项的操作。
      objArray = objArray.reduce(function (item, next) {
        //这是针对数组项操作的函数，对于每个数组项，reduce方法都会将其调用一次
        //可使用最多四个参数来声明回调函数（第一个参数：通过上一次调用回调函数获得的值;第二个参数：当前数组元素的值；第三个参数：当前数组元素的数字索引；第四个参数：包含该元素的数组对象）
        //这里只使用了两个参数，所以item和next分别代表上一次调用回调函数后的值和objArray项值
        hash[next[propertyName]]
          ? ""
          : (hash[next[propertyName]] = true && item.push(next)); //与func3逻辑相似
        return item;
      }, []); //初始值是一个空对象，使用reduce方法返回的是空对象通过叠加执行之后的结果
      return objArray;
    },
    ///移动端上传照片
    usePhoneType(ele) {
      const _this = this;
      if (mui.os.plus) {
        let buttonTit = [
          {
            title: "拍照"
          },
          {
            title: "从手机相册选择"
          }
        ];
        plus.nativeUI.actionSheet(
          {
            // title: "上传图片",
            cancel: "取消",
            buttons: buttonTit
          },
          function (b) {
            /*actionSheet 按钮点击事件*/
            switch (b.index) {
              case 0:
                break;
              case 1:
                _this.getImage(ele); /*拍照*/
                break;
              case 2:
                _this.galleryImg(ele); /*打开相册*/
                break;
              default:
                break;
            }
          }
        );
      }
    },
    // 拍照获取图片
    getImage(ele) {
      const _this = this;
      let c = plus.camera.getCamera();
      c.captureImage(
        function (e) {
          plus.io.resolveLocalFileSystemURL(
            e,
            function (entry) {
              if (plus.os.name == "Android") {
                let imgSrc =
                  entry.toLocalURL() + "?version=" + new Date().getTime(); //拿到图片路径
                localStorage.setItem("cropimg", imgSrc);
                localStorage.setItem("cropele", ele);
                _this.showPage = false;
              } else {
                localStorage.setItem("cropimg", entry.__remoteURL__);
                localStorage.setItem("cropele", ele);
                _this.showPage = false;
              }
            },
            function (e) {
              console.log("读取拍照文件错误：" + e.message);
            }
          );
        },
        function (s) {
          console.log("error" + s);
        },
        {
          filename: "_doc/camera/"
        }
      );
    },
    toDecimal(x) {
      if (x !== ".") {
        let f = Math.round(x * 100) / 100;
        let s = f.toString();
        let rs = s.indexOf(".");
        if (rs <= 0) {
          rs = s.length;
          s += ".";
        }
        while (s.length <= rs + 2) {
          s += "0";
        }
        return s;
      } else {
        return "0.00";
      }
    },
    // 从相册中选择图片
    galleryImg(ele) {
      const _this = this;
      // 从相册中选择图片
      plus.gallery.pick(
        function (e) {
          try {
            var imgtype = e.toLowerCase().split(".");
            if (imgtype[1] == "heic") {
              Toast("不支持heic图片格式，请选择jpg或者png格式图片");
              return "";
            }
          } catch (error) { }
          if (plus.os.name == "Android") {
            localStorage.setItem("cropimg", e);
            localStorage.setItem("cropele", ele);
            _this.showPage = false;
          } else {
            plus.io.resolveLocalFileSystemURL(e, function (entry) {
              localStorage.setItem("cropimg", entry.__remoteURL__);
              localStorage.setItem("cropele", ele);
              _this.showPage = false;
            })
          }
        },
        function (e) {
          console.log("取消选择图片");
        },
        {
          filter: "image"
        }
      );
    },
    setHtml(src, ele) {
      var _this = this;
      var base64 = src;
      if (ele <= 3) {
        _this.uploadPicture(base64, ele);
      } else {
        let imgSize = _this.getBase64Url(base64);
        if (imgSize >= 4) {
          _this.compressPicture(base64, ele); //大于4m再压缩
        } else {
          _this.uploadPicture(base64, ele);
        }
      }
    },
    // 图片转base64
    getBase64(img) {
      //传入图片路径，返回base64
      function getBase64Image(img, width, height) {
        //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
        let canvas = document.createElement("canvas");
        canvas.width = width ? width : img.width / 4;
        canvas.height = height ? height : img.height / 4;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // let ext = img.src.substring(img.src.lastIndexOf(".")+1).toLowerCase();//图片格式
        // let dataURL = canvas.toDataURL("image/"+ext, 0.7);
        let dataURL = canvas.toDataURL();
        canvas.toBlob(blob => { });
        return dataURL;
      }
      let image = new Image();
      image.crossOrigin = "";
      image.src = img;
      let deferred = $.Deferred();
      if (img) {
        image.onload = function () {
          deferred.resolve(getBase64Image(image)); //将base64传给done上传处理
        };
        return deferred.promise(); //问题要让onload完成后再return sessionStorage['imgTest']
      }
    },
    // 获取base64图片的大小
    getBase64Url(base64url) {
      //获取base64图片大小，返回MB数字
      // let str = base64url.split(",")[1];
      let str = base64url.replace("data:image/png;base64,", "");
      let equalIndex = str.indexOf("=");
      if (str.indexOf("=") > 0) {
        str = str.substring(0, equalIndex);
      }
      let strLength = str.length;
      let fileLength = parseInt(strLength - (strLength / 8) * 2);
      // 由字节转换为MB
      let size = "";
      size = (fileLength / (1024 * 1024)).toFixed(2);
      let sizeStr = size + ""; //转成字符串
      let index = sizeStr.indexOf("."); //获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
      if (dou == "00") {
        //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return parseInt(size);
    },
    compressPicture(blob, ele) {
      const _this = this;
      let quality = 0.5,
        image = new Image();
      image.src = blob;
      image.onload = function () {
        let that = this;
        // 生成比例
        let width = that.width,
          height = that.height;
        width = width / 4;
        height = height / 4;
        // 生成canvas画板
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(that, 0, 0, width, height);
        // 生成base64,兼容修复移动设备需要引入mobileBUGFix.js
        let imgurl = canvas.toDataURL("image/jpg", quality);
        // 修复IOS兼容问题
        if (navigator.userAgent.match(/iphone/i)) {
          let mpImg = new MegaPixImage(image);
          mpImg.render(canvas, {
            maxWidth: width,
            maxHeight: height,
            quality: quality
          });
          imgurl = canvas.toDataURL("image/jpg", quality);
        }
        // 上传照片
        _this.uploadPicture(imgurl, ele);
      };
    },
    //base64转blob
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mimeString
      });
    },
    //APP分享功能== doshare（'分享链接地址','分享标题','分享内容','分享到微信的图片','分享到QQ的图片'）{}===
    doshare(Href, Title, Message, Thumbs, Pictures, Indexid) {
      // console.log('Thumbs='+Thumbs)
      // console.log('我的图标='+Pictures)
      mui.init({
        swipeBack: true //启用右滑关闭功能
      });
      var Intent = null,
        File = null,
        Uri = null,
        main = null,
        shares = null,
        shareImageUrl = "";
      mui.plusReady(function () {
        updateSerivces();
        if (plus.os.name == "Android") {
          Intent = plus.android.importClass("android.content.Intent");
          File = plus.android.importClass("java.io.File");
          Uri = plus.android.importClass("android.net.Uri");
          main = plus.android.runtimeMainActivity();
        }
      });
      /**
       * 更新分享服务
       */
      function updateSerivces() {
        plus.share.getServices(
          function (s) {
            console.log(s);
            shares = {};
            for (var i in s) {
              var t = s[i];
              shares[t.id] = t;
            }
            outSet("获取分享服务列表成功");
            shareHref();
            // shareAction(keyId, keyValue)
          },
          function (e) {
            outSet("获取分享服务列表失败：" + e.message);
          }
        );
      }
      /**
       * 分享操作
       */
      function shareAction(id, ex) {
        var s = null;
        if (!id || !(s = shares[id])) {
          outLine("无效的分享服务！");
          return;
        }
        if (s.authenticated) {
          outSet("---已授权---");

          shareMessage(s, ex);
        } else {
          outSet("---未授权---");
          s.authorize(
            function () {
              shareMessage(s, ex);
            },
            function (e) {
              outLine("认证授权失败");
            }
          );
        }
      }
      /**
       * 发送分享消息
       */
      function shareMessage(s, ex) {
        if (Href == "") {
          var msg = {
            type: "image",
            pictures: [Pictures],
            extra: {
              scene: ex
            }
          };
        } else {
          var msg = {
            // type:'web',
            content: "分享-详情",
            href: Href,
            title: Title,
            content: Message,
            thumbs: [Thumbs],
            pictures: [Pictures],
            extra: {
              scene: ex
            }
          };
          if (ex != undefined && ex != null && ex.indexOf("WX") != -1) {
            msg = {
              type: "web",
              content: "分享-详情",
              href: Href,
              title: Title,
              content: Message,
              // thumbs: [Thumbs],
              pictures: [Pictures],
              extra: {
                scene: ex
              }
            };
          }
        }

        s.send(
          msg,
          function () {
            outLine("分享成功!");
          },
          function (e) {
            console.log(e);
            outLine("分享失败!");
          }
        );
      }

      /**
       * 分享按钮点击事件
       */
      function shareHref() {
        var ids = [
            {
              id: "weixin",
              ex: "WXSceneSession" /*微信好友*/
            },
            {
              id: "weixin",
              ex: "WXSceneTimeline" /*微信朋友圈*/
            },
            {
              id: "qq" /*QQ好友*/
            },
            {
              id: "tencentweibo" /*腾讯微博*/
            },
            {
              id: "sinaweibo" /*新浪微博*/
            }
          ],
          bts = [
            {
              title: "分享到微信好友"
            },
            {
              title: "分享到微信朋友圈"
            },
            {
              title: "分享到QQ"
            }
            // , {
            //     title: "分享到腾讯微博"
            // }, {
            //     title: "分享到新浪微博"
            // }
          ];
        if (Indexid != "" && Indexid != null && Indexid != undefined) {
          shareAction(ids[Indexid - 1].id, ids[Indexid - 1].ex);
        } else {
          plus.nativeUI.actionSheet(
            {
              cancel: "取消",
              buttons: bts
            },
            function (e) {
              var i = e.index;
              if (i > 0) {
                shareAction(ids[i - 1].id, ids[i - 1].ex);
              }
            }
          );
        }
      }
      // 控制台输出日志
      function outSet(msg) {
        console.log(msg);
      }
      // 界面弹出吐司提示
      function outLine(msg) {
        mui.toast(msg);
      }
    },
    // imgUrl：真实图片地址，layzImg默认图片地址
    lazyImg(imgUrl, layzImg) {
      return {
        src: imgUrl,
        error: layzImg,
        loading: layzImg
      };
    },

    getNowFormatDate() {
      //获取当前时间
      var date = new Date();

      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var currentdate =
        date.getFullYear() +
        month +
        strDate +
        date.getHours() +
        date.getMinutes() +
        date.getSeconds();
      return currentdate;
    },
    getSessionUserId() {
      let _userInfo = sessionStorage.getItem("UserInfo");
      if (_userInfo) {
        _userInfo = JSON.parse(_userInfo);
        return _userInfo.id;
      }
    },
  
    formatDate(date, fmt) {
      //日期格式化
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },

    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    // 判断ios
    isIOS() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isIOS;
    },
    // 判断微信
    isWX() {  
      var ua = navigator.userAgent.toLowerCase();  
      if(ua.match(/MicroMessenger/i)=="micromessenger") {  
          return true;  
      } else {  
          return false;  
      }  
    },
    // 判断支付宝
    isAlipay() {  
      if (/AlipayClient/.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    AndroidTimer(fn = function () { }) {
      // 启用定时器
      let that = this;
      var main = plus.android.runtimeMainActivity();
      var ALARM_RECEIVER = "alarm_receiver";
      var IntentFilter = plus.android.importClass(
        "android.content.IntentFilter"
      );
      var filter = new IntentFilter(ALARM_RECEIVER);
      var Build = plus.android.importClass("android.os.Build");
      var num = 1;
      global.timerStatus = true; // 默认开启定时器
      var receiver = plus.android.implements(
        "io.dcloud.android.content.BroadcastReceiver",
        {
          onReceive: function (context, intent) {
            //实现onReceiver回调函数
            calendar.add(Calendar.SECOND, 60);
            if (global.timerStatus) {
              if (num > 1) {
                fn();
              } else {
                // console.log('进来')
              }
              console.log("进入时间定时" + new Date());
              if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.M) {
                alarm.setExactAndAllowWhileIdle(
                  AlarmManager.RTC_WAKEUP,
                  calendar.getTimeInMillis(),
                  sender
                );
              } else if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.KITKAT) {
                alarm.setExact(
                  AlarmManager.RTC_WAKEUP,
                  calendar.getTimeInMillis(),
                  sender
                );
              } else {
                alarm.set(
                  AlarmManager.RTC_WAKEUP,
                  calendar.getTimeInMillis(),
                  sender
                );
              }
              num++;
            } else {
              alarm.cancel(sender); // 去除注册事件
              main.unregisterReceiver(receiver); //取消监听
              global.TimerReceiverInit = false;
            }
          }
        }
      );
      if (!global.TimerReceiverInit) {
        main.registerReceiver(receiver, filter);
        global.TimerReceiverInit = true;
        var Calendar = plus.android.importClass("java.util.Calendar");
        var calendar = Calendar.getInstance();
        if (global.TimerCalendar) {
          calendar.setTimeInMillis(Date.parse(new Date()));
          global.TimerCalendar = true;
        }
        calendar.add(Calendar.SECOND, 5);
        var Intent = plus.android.importClass("android.content.Intent");
        var intent = new Intent(ALARM_RECEIVER);
        var PendingIntent = plus.android.importClass(
          "android.app.PendingIntent"
        );
        var sender = PendingIntent.getBroadcast(main, 0, intent, 0);
        var AlarmManager = plus.android.importClass("android.app.AlarmManager");
        var Context = plus.android.importClass("android.content.Context");
        var alarm = main.getSystemService(Context.ALARM_SERVICE);
        if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.M) {
          alarm.setExactAndAllowWhileIdle(
            AlarmManager.RTC_WAKEUP,
            calendar.getTimeInMillis(),
            sender
          );
        } else if (Build.VERSION.SDK_INT >= Build.VERSION_CODES.KITKAT) {
          alarm.setExact(
            AlarmManager.RTC_WAKEUP,
            calendar.getTimeInMillis(),
            sender
          );
        } else {
          alarm.set(
            AlarmManager.RTC_WAKEUP,
            calendar.getTimeInMillis(),
            sender
          );
        }
      }
    },

    registerLight() {
      // 亮屏
      var g_wakelock = null;
      var main = plus.android.runtimeMainActivity();
      var Context = plus.android.importClass("android.content.Context");
      var PowerManager = plus.android.importClass("android.os.PowerManager");
      var pm = main.getSystemService(Context.POWER_SERVICE);
      g_wakelock = pm.newWakeLock(
        PowerManager.ACQUIRE_CAUSES_WAKEUP |
        PowerManager.SCREEN_BRIGHT_WAKE_LOCK,
        "bright"
      );
      g_wakelock.acquire();
      setTimeout(() => {
        g_wakelock.release();
      }, 2000);

      // console.log("亮屏时间打印=" + new Date());
    },
    playVoice(text) {
      let that = this;
      that.playIosAudio(text);
    },
    playIosAudio(text) {
      var AVAudioSession = plus.ios.importClass("AVAudioSession"),
        AVAudioSessionObj = AVAudioSession.sharedInstance();
      AVAudioSessionObj.setCategoryerror(
        "AVAudioSessionCategoryPlayback",
        null
      );
      AVAudioSessionObj.setActiveerror("YES", null);
      var AVSpeechSynthesizer = plus.ios.importClass("AVSpeechSynthesizer");
      var AVSpeechUtterance = plus.ios.importClass("AVSpeechUtterance");
      var AVSpeechSynthesisVoice = plus.ios.import("AVSpeechSynthesisVoice");
      var speech = new AVSpeechSynthesizer();
      var voice = AVSpeechSynthesisVoice.voiceWithLanguage("zh-CN");
      var utterance = AVSpeechUtterance.speechUtteranceWithString(text);
      utterance.setVoice(voice);
      speech.speakUtterance(utterance);
    },

    // 电话过滤
    filterPhone(phone) {
      // 1：全显示，2：部分显示
      let status = this.$store.getters.show_whole_phone;
      if (!status) {
        let filtPhone = phone.substr(0, 3) + "****" + phone.substr(-4);
        return filtPhone;
      } else {
        return phone;
      }
    },
    recodePageLog(state, msg) {
      // 记录闪退错误
      try {
        let Obj = JSON.parse(localStorage.getItem("logFailObj"));
        if (state) {
          Obj.errPage = msg;
          Obj.erroTime = this.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
        } else {
          Obj.errPage = "";
        }
        localStorage.setItem("logFailObj", JSON.stringify(Obj));
      } catch (error) { }
    }
  }
};
export default mixins;
